import React from "react";
import { Link } from "react-router-dom";
import "../styles/NotFound.css";

function NotFound() {

    return (
        <div className="container-fluid-bg">
            <div className="container not-found-card">
                <h4 className="fs-1">Ups... 404</h4>
                <p className="fs-4">Nie znaleziono strony</p>
                <Link to={"/"} className="btn btn-primary">Wróć do strony głównej</Link>
            </div>
        </div>
    )

}

export default NotFound;